import { Injectable } from "@angular/core";
import { SegmentService } from "@main-services/segment.service";
import { RudderstackService } from "@main-services/rudderstack.service";

@Injectable()
export class CashPlusTrackingFacade {
	private CP_DISCOVER_CASH_PLUS_BUTTON_CLICKED = "Discover Cash Plus Button Clicked";
	private CP_JOIN_CASH_PLUS_BUTTON_CLICKED = "Join Cash Plus Button Clicked";
	private CP_INTRO_SCREEN_VIEWED = "Cash Plus Intro Screen Viewed";
	private CP_GO_TO_WALLET = "Go To Wallet Button Clicked";
	private CP_JOIN_CASH_PLUSH_BUTTON_CLICKED = "Join Cash Plus Button Clicked";
	private CP_TURN_OFF_CASH_PLUS_BUTTON_CLICKED = "Turn Off Cash Plus Button Clicked";
	private CP_MOVE_CASH_PLUS_BUTTON_CLICKED = "Confirm Move Of Cash Plus Balance Button Clicked";
	private CP_WALLET_DETAILS_CP_WIDGET_VIEWED = "Wallet Details Cash Plus Widget Viewed";
	private CP_DEPOSIT_TO_EARN_BUTTON_CLICKED = "Deposit To Earn Button Clicked";

	constructor(
		private readonly segmentService: SegmentService,
		private readonly rudderstackService: RudderstackService
	) {}

	public trackBannerClick(location: string): void {
		this.tracker(location, this.CP_JOIN_CASH_PLUS_BUTTON_CLICKED);
	}

	public trackMoveBalanceToWalletBtnClick(location: string): void {
		this.tracker(location, this.CP_GO_TO_WALLET);
	}

	public introScreenViewed(): void {
		this.segmentService.page({ name: this.CP_INTRO_SCREEN_VIEWED });
		this.rudderstackService.page({ name: this.CP_INTRO_SCREEN_VIEWED });
	}

	public turnOffCashPlusBtnClicked(): void {
		this.segmentTracking(this.CP_TURN_OFF_CASH_PLUS_BUTTON_CLICKED);
		this.rudderstackTracking(this.CP_TURN_OFF_CASH_PLUS_BUTTON_CLICKED);
	}

	public walletCashOutCmpViewed(): void {
		this.segmentService.page({ name: "Move Cash Plus Balance to Wallet Screen Viewed" });
		this.rudderstackService.page({ name: "Move Cash Plus Balance to Wallet Screen Viewed" });
	}

	public cashOutClicked(): void {
		this.segmentTracking(this.CP_MOVE_CASH_PLUS_BUTTON_CLICKED);
		this.rudderstackTracking(this.CP_MOVE_CASH_PLUS_BUTTON_CLICKED);
	}

	public discoverCashPlusClicked(location: string): void {
		this.tracker(location, this.CP_DISCOVER_CASH_PLUS_BUTTON_CLICKED);
	}

	public portfolioWidgetViewed(): void {
		this.segmentService.page({ name: this.CP_WALLET_DETAILS_CP_WIDGET_VIEWED });
		this.rudderstackService.page({ name: this.CP_WALLET_DETAILS_CP_WIDGET_VIEWED });
	}

	public startEarningClicked(): void {
		this.segmentTracking(this.CP_JOIN_CASH_PLUSH_BUTTON_CLICKED);
		this.rudderstackTracking(this.CP_JOIN_CASH_PLUSH_BUTTON_CLICKED);
	}

	public depositToEarnButtonClicked(): void {
		this.segmentTracking(this.CP_DEPOSIT_TO_EARN_BUTTON_CLICKED);
		this.rudderstackTracking(this.CP_DEPOSIT_TO_EARN_BUTTON_CLICKED);
	}

	private segmentTracking(name: string): void {
		this.segmentService.track({ name });
	}

	private rudderstackTracking(name: string): void {
		this.rudderstackService.track({ name });
	}

	private tracker(location: string, event: string): void {
		this.segmentService.track({
			name: event,
			properties: {
				screen_it_happened_on: location
			}
		});
		this.rudderstackService.track({
			name: event,
			properties: {
				screen_it_happened_on: location
			}
		});
	}
}
